import ActionType from './actionType';

export const setExternalAccessConfig = (data) => ({
  type: ActionType.SET_EXTERNAL_ACCESS_CONFIG,
  payload: { externalAccessConfig: data },
});
